module.exports = __webpack_public_path__ + "img/menu_bottom_5.5063146a.svg";